'use memo';

import {
  useGetAgencyInformationForUser,
  useInvalidateUseGetAgencyInformationForUser,
} from '@urbanx/agx.agencies.client';
import {
  AgxButton,
  AgxSpacer,
  AgxTypography,
  useFirstPaintLoader,
} from '@urbanx/agx.ui-components2';
import { Navigate, Outlet } from 'react-router-dom';

import './RequireIntegrationAccessLayout.scss';

const RequireIntegrationAccessLayout = () => {
  const { data: agencyInformation, isPending } = useGetAgencyInformationForUser();
  const invalidateAgencyInformation = useInvalidateUseGetAgencyInformationForUser();

  useFirstPaintLoader({ isInitialLoadComplete: !isPending });

  if (isPending) return null;

  if (!agencyInformation) {
    return (
      <AgxSpacer
        direction="vertical"
        gap="spacing-lg"
        padding="spacing-3xl"
        contentAlignment="center"
        contentJustification="center"
        className="integration-access-error"
      >
        <AgxTypography
          id="agency-information-error"
          type="body_ui"
          size="medium"
          color="var(--text-tertiary, #94a3b8)"
        >
          Unable to load your agency information.
        </AgxTypography>
        <AgxButton
          id="retry-agency-information"
          text="Try again"
          variant="primary"
          onClick={() => void invalidateAgencyInformation()}
        />
        <AgxSpacer
          direction="horizontal"
          gap="spacing-md"
          contentAlignment="center"
          contentJustification="center"
          wrap
        >
          <AgxTypography
            id="agency-information-support-label"
            type="body_ui"
            size="medium"
            color="var(--text-tertiary, #94a3b8)"
          >
            Need help?
          </AgxTypography>
          <a id="agency-information-contact-support" href="mailto:support@autopilot.com.au">
            <AgxTypography
              id="agency-information-contact-support-label"
              type="hyperlink"
              size="medium"
            >
              Contact Autopilot Support
            </AgxTypography>
          </a>
        </AgxSpacer>
      </AgxSpacer>
    );
  }

  if (!agencyInformation.hasAccess) {
    return <Navigate to="/onboarding" replace />;
  }

  return <Outlet />;
};

export default RequireIntegrationAccessLayout;
